import { General } from '@/api/general'

import {GET_TARGET_PROTOKOL} from './types/index'

const state = {
    currentViewName:''
}

const getters = {
}

const mutations = {
    setCurrentViewName (state, payload) {
        state.currentViewName = payload
    }
}

const actions = {
  [GET_TARGET_PROTOKOL] ({paymentId}) {
    return General[GET_TARGET_PROTOKOL](paymentId)
      .then((response) => {
        var fileBytes = this.$base64ToArrayBuffer(response)
        this.$saveByteArray([fileBytes], 'proto.pdf')
        //
        // console.log(response)
        // const url = window.URL.createObjectURL(new Blob([response.data]))
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', 'protocol.pdf')
        // document.body.appendChild(link)
        // link.click()
      })
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
